module.exports = __webpack_public_path__ + "media/images/recrutare/services/service_etablissements_de_sante-bee65ec45ad579f8ba130eeb9fbaf750.png";